import React from 'react';
import styled from 'react-emotion';
import Link from 'gatsby-link';

const StyledAside = styled('aside')`
  width: 260px;
  background-color: ${props => props.theme.colors.navy700};
  height: 100%;
  min-height: 100vh;
  position: sticky;
  top: 0;
`;

const StyledAsideHeader = styled('div')`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.navy300};
  background-color: ${props => props.theme.colors.navy600};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  padding: 16px 32px;

  a {
    text-decoration: none;
    color: inherit;
  }
`;

const StyledList = styled('ul')`
  margin: 16px 0 0;
  padding: 0;
`;

const StyledListItem = styled('li')`
  margin: 0;
  width: 100%;
  padding: 8px 8px 8px 32px;
  font-size: 16px;
  font-weight: 500;
  color: ${props => props.theme.colors.white};

  a {
    text-decoration: none;
    color: inherit;
  }
`;

const BrandLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    style={{marginBottom: 8}}
    viewBox="0 0 368 161"
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M31.4925825,84.3854667 C35.6191845,84.3854667 39.0919612,82.6216222 42.3503689,79.3175444 L76.0152233,44.0657 C79.2736311,40.5398 82.9643495,38.7759556 87.3106796,38.7759556 C100.340738,38.7759556 105.553476,55.0798889 97.7343689,63.0154 L63.199534,97.6053556 L96.648233,132.8572 C102.51301,139.245322 102.947107,148.059178 97.0841165,154.449089 C94.4759612,157.3131 90.9996117,158.856911 86.6568544,158.856911 C82.0979417,158.856911 78.4036505,157.093067 75.5811262,153.7872 L42.3503689,117.4334 C39.3134757,114.129322 35.8353398,112.367267 31.9266796,112.367267 L29.1041553,112.367267 L29.1041553,143.873178 C29.1041553,152.467 23.0214369,159.078733 14.5502913,159.078733 C6.73297087,159.078733 0,152.026933 0,143.873178 L0,15.2019778 C-3.17329765e-15,6.60994444 6.51502913,0 14.5502913,0 C22.5891262,0 29.1041553,6.60994444 29.1041553,15.2019778 L29.1041553,84.3854667 L31.4925825,84.3854667 Z M205.013515,137.265022 C205.013515,141.891089 203.277126,145.195167 199.80435,147.6209 C188.074796,155.772867 172.87068,159.737044 153.975845,159.737044 C124.221437,159.737044 108.149126,143.214867 108.149126,120.961089 C108.149126,100.469367 122.701204,85.0473556 152.889709,85.0473556 C159.840621,85.0473556 167.87767,86.1493111 176.999068,88.3532222 L176.999068,82.4033778 C176.999068,70.7255111 171.134291,65.2157333 156.366058,65.2157333 C150.068971,65.2157333 143.116272,66.5395111 135.515107,68.9634556 C123.571184,72.7093889 115.534136,66.9777889 115.534136,57.5056222 C115.534136,51.1157111 118.790757,46.7096778 125.091417,44.0657 C133.562563,40.3197667 144.202408,38.5559222 157.016311,38.5559222 C188.94299,38.5559222 205.013515,53.5396556 205.013515,83.2835111 L205.013515,137.265022 L205.013515,137.265022 Z M176.999068,128.893022 L176.999068,109.059611 C169.178175,106.637456 162.011107,105.5355 155.278136,105.5355 C143.768311,105.5355 136.383301,111.263522 136.383301,119.857344 C136.383301,129.3313 143.768311,134.619256 155.930175,134.619256 C163.96901,134.619256 171.132505,132.633589 176.999068,128.889444 L176.999068,128.893022 Z M248.178485,144.821289 C248.178485,153.413322 242.095767,160.023267 233.624621,160.023267 C225.807301,160.023267 219.07433,152.973256 219.07433,144.821289 L219.07433,16.3683333 C219.07433,7.7763 225.589359,0.948111111 233.624621,0.948111111 C241.663456,0.948111111 248.178485,7.7763 248.178485,16.3683333 L248.178485,144.821289 L248.178485,144.821289 Z M350.920155,147.252389 C341.366447,155.626178 329.420738,159.810389 315.084816,159.810389 C300.966835,159.810389 289.022913,155.626178 279.249476,147.252389 C269.476039,138.880389 264.045359,128.084444 262.96101,115.084589 C262.308971,104.7305 262.308971,94.1545889 262.96101,83.5786778 C264.045359,70.357 269.258097,59.5610556 279.031534,51.1890556 C288.806757,42.8170556 300.968621,38.6310556 315.086602,38.6310556 C329.420738,38.6310556 341.36466,42.8170556 350.921942,51.1890556 C360.477437,59.5610556 365.908117,70.357 366.994252,83.5786778 C367.646291,93.9345556 367.646291,104.508678 366.994252,114.862767 C365.908117,128.084444 360.477437,138.882178 350.920155,147.252389 L350.920155,147.252389 Z M338.108039,88.2029556 C337.459573,75.6449556 328.766913,66.8328889 315.086602,66.8328889 C301.836816,66.8328889 292.931573,75.2048889 291.845437,88.2029556 C291.193978,95.5336484 291.193978,102.907796 291.845437,110.238489 C292.931573,123.236556 301.836816,131.608556 315.086602,131.608556 C328.334602,131.608556 337.238058,123.236556 338.108039,110.238489 C338.760979,102.907862 338.760979,95.5335824 338.108039,88.2029556 L338.108039,88.2029556 Z"
    />
  </svg>
);

export default ({pages}) => {
  return (
    <StyledAside>
      <StyledAsideHeader>
        <BrandLogo />
        <Link to="/">API Documentation</Link>
      </StyledAsideHeader>

      <StyledList>
        {pages.edges.map(page => (
          <StyledListItem>
            <Link to={page.node.fields.slug}>
              {page.node.frontmatter.title}
            </Link>
          </StyledListItem>
        ))}
      </StyledList>
    </StyledAside>
  );
};



// WEBPACK FOOTER //
// ./src/components/aside.js